import { CALL_API, Schemas } from '../../common/middleware/api';

export const TRIAL_LESSONS_REQUEST = 'TRIAL_LESSONS_REQUEST';
export const TRIAL_LESSONS_SUCCESS = 'TRIAL_LESSONS_SUCCESS';
export const TRIAL_LESSONS_FAILURE = 'TRIAL_LESSONS_FAILURE';

export const TRIAL_LESSON_DELETE_REQUEST = 'TRIAL_LESSON_DELETE_REQUEST';
export const TRIAL_LESSON_DELETE_SUCCESS = 'TRIAL_LESSON_DELETE_SUCCESS';
export const TRIAL_LESSON_DELETE_FAILURE = 'TRIAL_LESSON_DELETE_FAILURE';


export const loadTrialLessons = (options) => ({
	[CALL_API]: {
		types: [TRIAL_LESSONS_REQUEST, TRIAL_LESSONS_SUCCESS, TRIAL_LESSONS_FAILURE],
		endpoint: 'api/trialLessons',
		request: options,
		schema: Schemas.TRIAL_LESSON_ARRAY
	}
});

export const deleteTrialLesson = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [TRIAL_LESSON_DELETE_REQUEST, TRIAL_LESSON_DELETE_SUCCESS, TRIAL_LESSON_DELETE_FAILURE],
		endpoint: `api/trialLessons/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});